import { ReactElement, useState, useCallback } from 'react';
import { useEffect } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { FormHandles } from '@unform/core';
import { useForm } from 'react-hook-form';

import { Input, InputRadio, Select } from '~/components';
import { useLoading } from '~/hooks/loading';
import { CouponType, ICoupon, ICouponRequiredForm } from '~/models/Coupon';
import { CouponService } from '~/services';

import * as S from './styles';

interface IEditCouponsFormProps {
  formName: string;
  formRef: React.RefObject<FormHandles>;
  handleSubmit: (data: unknown) => void;
  couponId?: string;
}

interface ITypeOptions {
  label: CouponType;
  id: CouponType;
}

function EditCouponsForm({
  formName,
  formRef,
  handleSubmit,
  couponId,
}: IEditCouponsFormProps): ReactElement {
  const { setLoading } = useLoading();

  const [coupon, setCoupon] = useState<ICoupon>();
  const [initialData, setInitialData] = useState<ICouponRequiredForm>();

  const typeOptions: ITypeOptions[] = [
    { label: 'Fixo', id: 'Fixo' },
    { label: 'Percentual', id: 'Percentual' },
  ];

  const handleGetCoupon = useCallback(() => {
    setLoading(true);

    const response = CouponService.getAllCoupons();

    setCoupon(response.data?.find((i) => i.id === couponId));

    setLoading(false);
  }, [couponId]);

  useEffect(() => {
    handleGetCoupon();
  }, [handleGetCoupon]);

  useEffect(() => {
    setInitialData({
      code: coupon?.code ?? '',
      type: coupon?.type ?? 'Fixo',
      value: coupon?.value ?? '',
      validity: coupon?.validity ?? '',
    });
    formRef.current?.setFieldValue('type', coupon?.type);
    formRef.current?.setFieldValue('validity', coupon?.validity);
  }, [coupon, formRef]);

  return (
    <S.FormWrapper
      id={formName}
      ref={formRef}
      onSubmit={handleSubmit}
      initialData={initialData}
    >
      <Input label="Código" name="code" />
      <S.InputBlock>
        <p>Tipo</p>
        <InputRadio name="type" options={typeOptions} />
      </S.InputBlock>
      <Input label="Valor" name="value" />
      <S.InputBlock>
        <p>Validade</p>
        <Select
          name="validity"
          options={[{ label: '20/12/2020', value: '20/12/2020' }]}
        />
      </S.InputBlock>
    </S.FormWrapper>
  );
}

EditCouponsForm.defaultProps = {
  couponId: '',
};

export default EditCouponsForm;
